import { TRADE_AMOUNT_TYPE, TRADE_TYPE } from "../constants";

import { BadgeShape } from "./TradeInput";
import Big from "big.js";
import { Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import { useSelector } from "react-redux";

function GoldTotal({ sourceCoin }) {
  const { watch } = useFormContext();

  const amount = watch("amount");
  const amountTypeId = watch("amountTypeId");
  const price = watch("price");
  const walletTypeId = watch("walletTypeId");

  const tradeAmountMax = useSelector(
    (state) => state.trade?.tradeAmountMax?.data
  );

  const goldValue = useMemo(() => {
    if (amount && sourceCoin?.coinCoefficient && tradeAmountMax?.price) {
      const bigAmount = new Big(+amount || 0);
      const bigCoinCoefficient = new Big(+sourceCoin?.coinCoefficient || 0);
      const bigPrice = new Big(+tradeAmountMax?.price || 0);
      const bigValuePrice = new Big(price ? +price : 0);

      if (amountTypeId === TRADE_AMOUNT_TYPE.amount.id) {
        const totalGold = bigAmount.times(bigCoinCoefficient);

        return totalGold.toString();
      }
      if (amountTypeId === TRADE_AMOUNT_TYPE.total.id) {
        if (walletTypeId === TRADE_TYPE.market.id) {
          const totalGold = bigAmount.div(bigPrice).times(bigCoinCoefficient);

          return totalGold.toString();
        } else {
          const totalGold = bigAmount
            .div(bigValuePrice)
            .times(bigCoinCoefficient);

          return totalGold.toString();
        }
      }
    } else return "";
  }, [
    amount,
    sourceCoin?.coinCoefficient,
    price,
    amountTypeId,
    walletTypeId,
    tradeAmountMax?.price,
  ]);

  return (
    <>
      {goldValue && (
        <BadgeShape>
          <Typography textAlign="center" color="text.main" variant="subtitle1">
            {goldValue} <br />
            {sourceCoin?.coinFineness}
          </Typography>
        </BadgeShape>
      )}
    </>
  );
}

export default GoldTotal;
